import {
  onContractApiProps,
  UpcomingOnContractResponse,
} from '../../../types/Dashboard/OnContract/onContractTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { dashboardApiConfig, AllowedHttpMethods } from '../apiList'

const getEmployeesUnderOnContract = async (
  props: onContractApiProps,
): Promise<UpcomingOnContractResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getEmployeesUnderOnContract,
    method: AllowedHttpMethods.get,
    params: {
      employeeId: props.employeeId,
      endIndex: props.endIndex ?? 20,
      startIndex: props.startIndex ?? 0,
    },
  })

  const response = await useAxios(requestConfig)
  const data = response.data as unknown as
    | UpcomingOnContractResponse
    | { list?: unknown; size?: number }
    | unknown[]
    | { data?: unknown[]; size?: number }

  let list: UpcomingOnContractResponse['list'] = []
  let size = 0

  if (Array.isArray(data)) {
    list = data as UpcomingOnContractResponse['list']
    size = list.length
  } else if (data && typeof data === 'object') {
    const obj = data as { list?: unknown; size?: number; data?: unknown }
    if (Array.isArray(obj.list)) {
      list = obj.list as UpcomingOnContractResponse['list']
      size = obj.size ?? list.length
    } else if (Array.isArray(obj.data)) {
      list = obj.data as UpcomingOnContractResponse['list']
      size = obj.size ?? list.length
    }
  }

  return { list, size }
}

const employeeOnContractApi = {
  getEmployeesUnderOnContract,
}

export default employeeOnContractApi
